var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon illustrative"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.175 2.985L10.81 1.76C10.675 1.31 10.255 0.994995 9.785 0.994995H7.215C6.74 0.994995 6.325 1.305 6.19 1.76L5.825 2.985H2.5V3.98499H3.455L4.03 15H12.965L13.54 3.98499H14.5V2.985H11.175ZM7.145 2.05C7.155 2.02 7.18 2 7.215 2H9.785C9.815 2 9.845 2.02 9.85 2.05L10.11 2.92H6.885L7.145 2.05ZM11.995 11.995C11.895 13.43 10.315 13.505 10 13.505H6.98C6.42 13.505 5.105 13.36 5.005 11.995L4.47 4.105H12.53L11.995 11.995ZM7 5.505H6V12.005H7V5.505ZM9 5.505H8V12.005H9V5.505ZM11 5.505H10V12.005H11V5.505Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDeleteIcon);
export default __webpack_public_path__ + "static/media/custom_delete_icon.97ede3745af1514b5bd5b5d508c2d8ed.svg";
export { ForwardRef as ReactComponent };